import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rule-container" }
const _hoisted_2 = { class: "delete-icon" }
const _hoisted_3 = { class: "clause" }
const _hoisted_4 = { class: "condition" }
const _hoisted_5 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_6 = { class: "action" }
const _hoisted_7 = { class: "condition" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}

import ConditionGroupBuilder, { ConditionGroupUpdate } from '@/shared/components/conditions/ConditionGroupBuilder.vue';
import CapableAppPicker from '@/shared/components/capableAppPicker/CapableAppPicker.vue';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import { botsApi } from '../../services/bots';
import { RuleViewModel } from '../../models/ruleViewModel';
import { required, minLength } from '@vuelidate/validators';
import TagBox from '@/shared/components/TagBox.vue';
import { FollowUpActionViewModel, FollowUpActionType, BotActionAppViewModel } from '../../models';
import { PropType, ref, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import { IConditionsManager } from '@shared/components/conditions/models/conditionsManager';


export default /*@__PURE__*/_defineComponent({
  __name: 'Rule',
  props: {
  rule: {
    type: Object as PropType<RuleViewModel>,
    required: true,
  },
  ruleConditionsManager: {
    type: Object as PropType<IConditionsManager>,
    required: true,
  },
},
  emits: ["updated", "deleted"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasInvalidConditions = ref(false);
const providedRule = ref<RuleViewModel>({
  conditions: {
    type: 'and',
    conditions: [],
  },
  actions: [],
});

const validations = {
  providedRule: {
    required,
    conditions: {
      conditions: {
        required,
        minLength: minLength(1),
      },
    },
    actions: {
      required,
      minLength: minLength(1),
    },
  },
};

const $v = useVuelidate(validations, { providedRule });

watch(
  () => props.rule,
  (value) => {
    if (value) {
      providedRule.value = value;
    }
  },
  { immediate: true, deep: true },
);

function conditionUpdated(update: ConditionGroupUpdate) {
  hasInvalidConditions.value = update.invalid;
  const clone = JSON.parse(JSON.stringify(providedRule.value)); // to prevent updating the providedRule which would kick off processing in child
  clone.conditions = update.conditionGroup;
  emit('updated', clone, hasInvalidConditions.value);
}

function actionsChanged(selectedApps: BotActionAppViewModel[]) {
  const appActions = selectedApps.map<FollowUpActionViewModel>((app) => ({
    type: FollowUpActionType.AppIntegration,
    app,
  }));
  providedRule.value.actions = appActions;
  emit('updated', providedRule.value, hasInvalidConditions.value);
}

function configRequest(
  workspaceId: string,
  installedAppId: string,
  values: any,
  previousValues: any,
  componentId: any,
) {
  return botsApi.botAppConfig(workspaceId, installedAppId, values, previousValues, componentId);
}

function deleteRule() {
  emit('deleted');
}

function getSelectedFollowUpApps(): Array<ConfiguredAppIntegration> {
  return providedRule.value.actions
    .filter((action) => action.type === FollowUpActionType.AppIntegration)
    .filter((action) => action.app !== undefined)
    .map((action) => action.app);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        onClick: deleteRule,
        class: "trash-icon"
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("use", {
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xlink:href": "#trash"
        }, null, -1)
      ]))]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TagBox, { value: "if" }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ConditionGroupBuilder, {
          value: providedRule.value.conditions,
          manager: __props.ruleConditionsManager,
          disabled: false,
          context: "condition",
          onUpdated: conditionUpdated
        }, null, 8, ["value", "manager"]),
        (_unref($v).providedRule.conditions.conditions.$invalid && _unref($v).providedRule.$anyDirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Please provide a condition "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(TagBox, { value: "then" }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CapableAppPicker, {
          modalHeading: 'Bot Apps',
          capability: 'botActions',
          selectedApps: getSelectedFollowUpApps(),
          configRequest: configRequest,
          isLozengeMode: true,
          onChange: actionsChanged
        }, null, 8, ["selectedApps"]),
        (_unref($v).providedRule.actions.$invalid && _unref($v).providedRule.$anyDirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Please provide an action "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})